import React from "react";
import styles from "./Index.module.css"

// components
import PageHeader from '../../../PageHeader/PageHeader.js';
import PageInfo from '../../components/PageInfo';
import ContactInfo from '../../components/ContactInfo.js';
import ImageGallery from "../../components/ImageGallery.js"
import PageState from "../../components/PageState.js";

export default function JuniorTeen() {
    return(
        <PageState
            pageName="JuniorTeen"
            render={({ data, sections, sectionNames }) => {

                const { Sec1, Sec2, Sec3, Sec4, Sec5, u3, PageHeader: PageHeaderContent, Gallery } = data;

                return (
                    <div>
                        <PageHeader 
                            image={PageHeaderContent.imageUrl} 
                            title={PageHeaderContent.title} 
                            sections={sections} 
                            description={PageHeaderContent.text}
                            sectionNames={sectionNames}
                        />

                        <section id={Sec1.secId} className={styles.sec1}>
                            <PageInfo 
                                image={""} 
                                title={Sec1.header} 
                                version={"v1"} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec1.text }} />} 
                            />
                            <ContactInfo 
                                when={Sec1.when} 
                                where={Sec1.where} 
                                who={Sec1.who} 
                                mobile={Sec1.mobile} 
                            />
                        </section>

                        <section id={Sec2.secId} className={styles.sec2}>
                            <PageInfo 
                                image={""} 
                                title={Sec2.header} 
                                version={"v1"} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec2.text }} />} 
                            />
                            <ContactInfo 
                                when={Sec2.when} 
                                where={Sec2.where} 
                                who={Sec2.who} 
                                mobile={Sec2.mobile} 
                            />
                        </section>
                        <section className={styles.gallery}>
                            <ImageGallery images={Gallery.images}/>
                        </section>

                        <section id={Sec3.secId} className={styles.sec1}>
                            <PageInfo 
                                image={""} 
                                title={Sec3.header} 
                                version={"v1"} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec3.text }} />} 
                            />
                            <ContactInfo 
                                when={Sec3.when} 
                                where={Sec3.where} 
                                who={Sec3.who} 
                                mobile={Sec3.mobile} 
                            />
                        </section>

                        <section id={Sec4.secId} className={styles.sec2}>
                            <PageInfo 
                                image={""} 
                                title={Sec4.header} 
                                version={"v1"} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec4.text }} />} 
                            />
                            <ContactInfo 
                                when={Sec4.when} 
                                where={Sec4.where} 
                                who={Sec4.who} 
                                mobile={Sec4.mobile} 
                            />
                        </section>

                        <section id={Sec5.secId} className={styles.sec1}>
                            <PageInfo 
                                image={""} 
                                title={Sec5.header} 
                                version={"v1"} 
                                description={<div dangerouslySetInnerHTML={{ __html: Sec5.text }} />} 
                            />
                            <ContactInfo 
                                when={Sec5.when} 
                                where={Sec5.where} 
                                who={Sec5.who} 
                                mobile={Sec5.mobile} 
                            />
                        </section>
                        {u3 &&(<section 
                            id ={u3.secId} 
                            className={styles.sec2}>

                            <PageInfo 
                                title={u3.header} 
                                description={<div dangerouslySetInnerHTML={{ __html: u3.text }}/>} 
                                image={""} 
                                version={"v1"}/>

                            <ContactInfo 
                                where= {u3.where} 
                                when={u3.when} 
                                who={u3.who} 
                                mobile={u3.mobile}
                                email={u3.email}/>
                        </section>)}
                    </div>
                );
            }
        }/>
    );
}
